/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: e0910cc98ac5
 */

import * as z from "zod";
import { uploadMappingsDeleteUploadMapping } from "../../funcs/uploadMappingsDeleteUploadMapping.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  folder: z.string().describe("The folder name of the mapping to delete"),
};

export const tool$uploadMappingsDeleteUploadMapping: ToolDefinition<
  typeof args
> = {
  name: "delete-upload-mapping",
  description: `Deletes a folder upload mapping

Permanently deletes the upload mapping for the specified folder`,
  scopes: ["builder"],
  annotations: {
    "title": "Delete Upload Mapping",
    "destructiveHint": true,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await uploadMappingsDeleteUploadMapping(
      client,
      args.folder,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
